module.exports = __webpack_public_path__ + "static/media/account.b7fd2d91.svg";